import { DataFieldTypeEnum } from "abweb/dto/generated/ds/DataFieldTypeEnum";
import { DataSourceState } from "abweb/dto/generated/ds/DataSourceState";
import { DataSourceValueDateTimeBase } from "abweb/dto/generated/ds/DataSourceValueDateTimeBase";
import * as AbWebResources from "abweb/generated/locale/AbWebResources";
import { ClassUtils } from "abweb/utils/ClassUtils";
import { DateTimeUtils } from "abweb/utils/date/DateTimeUtils";
import { DateUtils } from "abweb/utils/DateUtils";
import { DataSourceField } from "./DataSourceField";
import { DataSourceValue } from "./DataSourceValue";
export class DataSourceValueDateTime extends DataSourceValueDateTimeBase {
  static createWithReadOnlyDefaults(id, value, refID = null) {
    return DataSourceValueDateTime.createDataSourceValueDateTime(/*attributeValues*/null, /*clientTag*/null, /*dataSourceSaveAction*/null, id, /*baselineRefID*/null, refID, DataSourceState.NORMAL, /*baseline*/null, value, /*editableOverwrite*/null, /*fieldTypeOverwrite*/null);
  }
  static createWithFactoryDefaults(value, refID = null) {
    const dateValue = DataSourceValueDateTime.createDataSourceValueDateTime(/*attributeValues*/null, /*clientTag*/null, /*dataSourceSaveAction*/null, /*id*/null, /*baselineRefID*/null, refID, DataSourceState.NORMAL, /*baseline*/null, value, /*editableOverwrite*/null, /*fieldTypeOverwrite*/null);
    dateValue._field = DataSourceField.createWithDefaults(DataFieldTypeEnum.DATETIME, "Name");
    return dateValue;
  }
  static createDataSourceValueDateTime(attributeValues, clientTag, dataSourceSaveAction, id, baselineRefID, refID, state, baseline, value, editableOverwrite = null, fieldTypeOverwrite = null) {
    const retVal = new DataSourceValueDateTime();
    retVal.initDataSourceValueDateTime(attributeValues, clientTag, dataSourceSaveAction, editableOverwrite, id, state, baselineRefID, fieldTypeOverwrite, refID, baseline, null, value);
    return retVal;
  }
  constructor() {
    super();
  }
  initDataSourceValueDateTime(attributeValues, clientTag, dataSourceSaveAction, editableOverwrite, id, state, baselineRefID, fieldTypeOverwrite, refID, baseline, currentValue, value) {
    super.initDataSourceValueDateTime(attributeValues, clientTag, dataSourceSaveAction, editableOverwrite, id, state, baselineRefID, fieldTypeOverwrite, refID, baseline, currentValue, value);
    if (currentValue == null) {
      this.currentValue = value;
    }
  }
  getCurrentValue() {
    return this.currentValue;
  }
  getValue() {
    return this.value;
  }
  getBaseline() {
    return this.baseline;
  }
  get isDate() {
    return false;
  }
  get isDateTime() {
    return true;
  }
  getDisplayValue() {
    const date = this.get("currentValue");
    return this.getFormattedValue(date);
  }
  getFormattedValue(value) {
    const date = value;
    return this.formatDateTime(date);
  }

  /**
   * Formats DATE object by accounting for the local time zone offset.
   * This deals with the issue where the server always represents DATEs as 0Z, but if we are in the US which
   * is 4-8 hours behind GMT, a Date like 2/13/1997 0Z would get formatted as 2/12/1997.
   * So this method adds the local time zone offset (would be negative in Europe) and formats that resulting Date.
   * @param date Date object
   * @returns {string} Formatted date.
   */
  formatDateTime(date) {
    return date ? DateTimeUtils.DATETIME_WITH_SECONDS.format(date) : "";
  }
  validateValue(value) {
    const date = value;
    const error = super.validateValue(date);
    if (error != null) {
      return error;
    }
    if (this._field == null || this._field.validation == null) {
      // Nothing to validate
      return null;
    }
    const validation = this._field.validation;
    if (validation.dateRangeMin != null) {
      if (date == null || DateUtils.compare(date, validation.dateRangeMin) < 0) {
        return AbWebResources.rangeMinValidation(this.formatDateTime(validation.dateRangeMin));
      }
    }
    if (validation.dateRangeMax != null) {
      if (date == null || DateUtils.compare(date, validation.dateRangeMax) > 0) {
        return AbWebResources.rangeMaxValidation(this.formatDateTime(validation.dateRangeMax));
      }
    }
    return null;
  }

  /**
   * Tests for equality
   * @param value1 Assumed to be a Date object.
   * @param value2 Assumed to be a Date object.
   * @returns {boolean}
   */
  areEqual(value1, value2) {
    return DateUtils.areEqual(value1, value2);
  }
  coerceValue(value) {
    if (value == null) {
      return null;
    }
    if (ClassUtils.isInstanceOf(value, DataSourceValue)) {
      if (value.isReference) {
        throw new Error("Cannot coerce a REFERENCE value to DATE");
      }
      value = value.getCurrentValue();
    }
    if (value == null) {
      return null;
    }
    if (ClassUtils.isInstanceOf(value, Date)) {
      return DateUtils.clone(value);
    }
    const t = typeof value;
    if (t === "string") {
      const date = DateTimeUtils.kendoParseDate(value);
      if (date == null) {
        throw new Error(`Cannot coerce '${value.toString()}' to DATE`);
      }
      return date;
    }
    throw new Error(`Cannot coerce ${value.toString()} to DATE`);
  }
  initializeWithDefaultFieldValue(field) {
    if (field.defaultValue == null) {
      return;
    }
    const defaultValue = this.coerceValue(field.defaultValue);
    this.value = this.currentValue = defaultValue;
  }

  /**
   * Compare function that can be used for sorting.
   * @param bvalue Value to compare against.
   * @return negative number if this value is less than bvalue,
   * positive number if bvalue is less than this value, 0 if equal.
   */
  compare(bvalue) {
    let bd = bvalue;
    let a = this.currentValue;
    let b = bd == null ? null : bd.currentValue;
    return DateUtils.compare(a, b);
  }
}
//# sourceMappingURL=DataSourceValueDateTime.js.map
